(function() {
	'use strict';

	angular.module('resultUploadedCollectionApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider', '$urlRouterProvider',
			'GLOBAL_URL' ];

	function stateConfig($stateProvider, $urlRouterProvider, GLOBAL_URL) {
		$urlRouterProvider.otherwise("/resultUploaded");
		$stateProvider
				.state(
						'resultUploaded',
						{
							url : '/resultUploaded',
							data : {
								pageTitle : 'Result uploaded collection'
							},
							views : {
								'content@' : {
									templateUrl : GLOBAL_URL
											+ 'partial?uri=ga/result-uploaded-collection/template/result-upload-collection',
									controller : 'ResultUploadedController',
									controllerAs : 'resultCtrl'
								}
							}
						});
	}
})();
